import { NbMenuItem } from '@nebular/theme';
import { Permissions } from './config/AppEnums';

export const MENU_ITEMS: NbMenuItem[] = [
  //{
  //  title: 'E-commerce',
  //  icon: 'nb-e-commerce',
  //  link: '/pages/dashboard',
  //  home: true,
  //},
  //{
  //  title: 'IoT Dashboard',
  //  icon: 'nb-home',
  //  link: '/pages/iot-dashboard',
  //},
  //{
  //  title: 'FEATURES',
  //  group: true,
  //},
  {
    title: 'User Manuals',
    icon: 'fa fa-info',
    link: '/tutorial',
  },
  {
    title: 'Dashboard',
    icon: 'fa fa-chart-pie',
    link: '/dashboard/index',
    data: [Permissions.DashboardModule],
    hidden: true
  }, {
    title: 'IMS',
    icon: 'fa fa-folder',
    data: [Permissions.ImsModule, Permissions.EMSView, Permissions.EMSManage],
    hidden: true,
    children: [
      {
        title: 'IMS',
        icon: 'fa fa-folder',
        link: '/ims/index',
        data: [Permissions.ImsModule, Permissions.EMSView, Permissions.EMSManage],

      },
      {
        title: 'Reports',
        icon: 'fa fa-chart-line',
        link: 'primaryUrl/app-reports/ims',
        data: [Permissions.ImsModule, Permissions.EMSReports],
        hidden: true
      }]
  },
  {
    title: 'Capex',
    icon: 'fa fa-shopping-basket',
    data: [Permissions.CAPEX_Module, Permissions.CAPEX_CapexRequestor, Permissions.CAPEX_DisposalRequestor, Permissions.CAPEX_Admin,
    Permissions.CAPEX_CapexRequestor,
    Permissions.CAPEX_CEO,
    Permissions.CAPEX_FD,
    Permissions.CAPEX_FM,
    Permissions.CAPEX_MD,
    Permissions.CAPEX_Board,
    Permissions.CAPEX_ClosedOff,
    Permissions.CAPEX_OrderPlaced,
    Permissions.CAPEX_OrderReceived,
    Permissions.CAPEX_Shareholders,
    Permissions.CAPEX_DisposalRequestor,
    Permissions.CAPEX_DivisionReports,
    Permissions.CAPEX_GlobalReports],

    hidden: true,
    children: [
      {
        title: 'Classifications',
        icon: 'fa fa-archive',
        link: 'primaryUrl/capex/config',
        data: [Permissions.CAPEX_Admin],
        hidden: true
      },
      {
        title: 'Requests',
        icon: 'fa fa-shopping-basket',
        link: 'primaryUrl/capex/requests',
        data: [Permissions.CAPEX_CapexRequestor, Permissions.CAPEX_DisposalRequestor,
        Permissions.CAPEX_CEO,
        Permissions.CAPEX_FD,
        Permissions.CAPEX_FM,
        Permissions.CAPEX_MD,
        Permissions.CAPEX_Board,
        Permissions.CAPEX_ClosedOff,
        Permissions.CAPEX_OrderPlaced,
        Permissions.CAPEX_OrderReceived,
        Permissions.CAPEX_Shareholders],
        hidden: true
      },
      {
        title: 'Divisions',
        icon: 'fa fa-building',
        link: 'primaryUrl/capex/divisions',
        data: [Permissions.CAPEX_Admin],
        hidden: true
      },
      {
        title: 'Reports',
        icon: 'fa fa-chart-line',
        link: 'primaryUrl/capex/reports',
        data: [Permissions.ProcurementApproval, Permissions.CAPEX_GlobalReports],
        hidden: true
      }

    ]
  },
  {
    title: 'Employees / Candidates',
    icon: 'fa fa-users',
    data: [Permissions.SPS_Admin,
    Permissions.SPS_Edit,
    Permissions.SPS_Lookups,
    Permissions.SPS_View],
    hidden: true,
    children: [
      {
        title: 'Employees / Candidates',
        icon: 'fa fa-users',
        link: 'primaryUrl/sps/personnel',
        data: [Permissions.SPS_Admin,
        Permissions.SPS_Edit,
        Permissions.SPS_View],
      },
      {
        title: 'Reports',
        icon: 'fa fa-chart-line',
        link: 'primaryUrl/sps/reports',
        data: [Permissions.SPS_Admin,
        Permissions.SPS_Edit,
        Permissions.SPS_View],
      },
      {
        title: 'General Lookups',
        icon: 'fa fa-cog',
        link: 'primaryUrl/sps/lookups',
        data: [Permissions.SPS_Admin,
        Permissions.SPS_Lookups
        ],
      },
      {
        title: 'PPE Sizes',
        icon: 'fa fa-cog',
        link: 'primaryUrl/sps/ppe-lookups',
        data: [Permissions.SPS_Admin,
        Permissions.SPS_Lookups],
      }
    ]
  },
  {
    title: 'Requisitions',
    icon: 'fa fa-shopping-cart',
    data: [Permissions.RequisitionApproval, Permissions.RequisitionCreate, Permissions.StockRequisition,
    Permissions.ProcurementApproval, Permissions.RequisitionJobManagement],
    hidden: true,
    children: [

      {
        title: 'Dashboard',
        icon: 'fa fa-chart-pie',
        link: '/reqdashboard/index',
        data: [Permissions.ProcurementApproval],

      },
      {
        title: 'Reports',
        icon: 'fa fa-chart-line',
        link: '/reqreports/index',
        data: [Permissions.ProcurementApproval, Permissions.OutstandingItemsReport, Permissions.RequisitionCreate, Permissions.StockRequisition],

      },
      {
        title: 'Requisition list',
        icon: 'fa fa-shopping-cart',
        link: 'primaryUrl/requisition/index',
        data: [Permissions.RequisitionApproval, Permissions.RequisitionCreate, Permissions.StockRequisition,
        Permissions.ProcurementApproval],
      }

    ]
  },
  {
    title: 'KPI',
    icon: 'fa fa-chart-line',
    data: [Permissions.Kpi_Capture, Permissions.Kpi_Reports, Permissions.Kpi_Admin],
    hidden: true,
    children: [

      {
        title: 'Dashboard',
        icon: 'fa fa-chart-pie',
        link: 'primaryUrl/kpi/dashboard',
        data: [Permissions.Kpi_Reports, Permissions.Kpi_Admin],

      }, 
      {
        title: 'Reports',
        icon: 'fa fa-chart-pie',
        link: 'primaryUrl/kpi/reports',
        data: [Permissions.Kpi_Reports, Permissions.Kpi_Admin],
      },
      {
        title: 'Data Entry',
        icon: 'fa fa-pencil',
        link: 'primaryUrl/kpi/index',
        data: [Permissions.Kpi_Capture, Permissions.Kpi_Admin],

      }

    ]
  },
  {
    title: 'Data Management',
    icon: 'fa fa-store-alt',
    link: '/stock/list',
    data: [Permissions.StockItemsModule, Permissions.StockItemsModuleView, Permissions.SupplierEdit, Permissions.SupplierManageDocuments, Permissions.ViewCreditors, Permissions.EditCreditors],
    hidden: true,
    children: [
      {
        title: 'Catalog',
        icon: 'fa fa-box-open',
        link: '/stock/list',
        data: [Permissions.StockItemsModuleView, Permissions.StockItemsModuleEdit],
      },
      {
        title: 'Suppliers',
        icon: 'fa fa-building',
        link: 'primaryUrl/stock/supplier',
        data: [Permissions.SupplierEdit, Permissions.SupplierManageDocuments],

      },
      {
        title: 'Creditors',
        icon: 'fa fa-building',
        link: 'primaryUrl/stock/creditors',
        data: [Permissions.SupplierEdit, Permissions.SupplierManageDocuments],

      },
      {
        title: 'Monthly Creditors Batch',
        icon: 'building',
        link: 'primaryUrl/stock/creditorsBatch',
        data: [Permissions.ViewCreditors, Permissions.EditCreditors],

      }
    ]

  },
  {
    title: 'Invoicing',
    icon: 'fa fa-file-invoice-dollar',
    link: '/stock/list',
    data: [Permissions.InvoicingModule, Permissions.InvoicingEdit, Permissions.InvoiceViewPermission],
    hidden: true,
    children: [
      {
        title: 'View Invoices',
        icon: 'fa fa-file-invoice-dollar',
        link: '/invoicing/index',
        data: [Permissions.InvoicingModule, Permissions.InvoicingEdit, Permissions.InvoiceViewPermission]
      },
      {
        title: 'Reports',
        icon: 'fa fa-chart-line',
        link: 'primaryUrl/app-reports/invoicing',
        data: [Permissions.InvoicingReports],
        hidden: true
      },
    ]

  },


  {
    title: 'Imports',
    icon: 'fa fa-upload',
    link: '/pages/ui-features',
    expanded: false,
    data: [Permissions.ImportsModule],
    hidden: true,
    children: [
      {
        title: 'Stock Items',
        icon: 'fa fa-upload',
        link: '/import/stock'
      }, {
        title: 'Suppliers',
        icon: 'fa fa-upload',
        link: '/import/supplier'
      },

    ]
  },
  {
    title: 'Admin',
    icon: 'fa fa-lock',
    link: '/pages/ui-features',
    expanded: false,
    data: [Permissions.SuperAdmin, Permissions.OrganisationManage, Permissions.SiteAdmin],
    hidden: true,
    children: [
      {
        title: 'General Ledgers',
        icon: 'fa fa-clipboard-list',
        link: 'primaryUrl/hr/ledgers',
        data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
      },
      {
        title: 'Users',
        icon: 'fa fa-users',
        link: 'primaryUrl/hr/users',
        hidden: true,
        data: [Permissions.SuperAdmin, Permissions.OrganisationManage, Permissions.SiteAdmin]
      },
      {
        title: 'Organisations',
        link: 'primaryUrl/hr/organisations',
        icon: 'fa fa-building',
        hidden: true,
        data: [Permissions.SuperAdmin]
      },
      {
        title: 'Jobs',
        link: 'primaryUrl/hr/jobs',
        icon: 'fa fa-building',
        hidden: true,
        data: [Permissions.SuperAdmin]
      },
      {
        title: 'Sites',
        link: 'primaryUrl/hr/sites',
        icon: 'fa fa-building',
        hidden: true,
        data: [Permissions.SuperAdmin]
      },
      {
        title: 'Global Roles',
        link: 'primaryUrl/hr/roles',
        icon: 'fa fa-user-shield',
        hidden: true,
        data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
      },
      {
        title: 'User Import',
        link: '/hr/userimport',
        icon: 'fa fa-upload',
        hidden: true,
        data: [Permissions.SuperAdmin]
      },



    ]
  },
  {
    title: 'My Profile',
    icon: 'fa fa-user',
    link: '/party/profile',
    expanded: false
  },
  {
    title: 'JCE',
    icon: 'fa fa-file-invoice-dollar',
    data: [Permissions.JSEModule],
    hidden: true,
    children: [
      {
        title: 'Work Orders',
        icon: 'fa fa-file-invoice-dollar',
        link: '/jse/workorders',
        data: [Permissions.JSEModule],
      },
      {
        title: 'Invoices',
        icon: 'fa fa-file-invoice-dollar',
        link: '/jse/invoices',
        data: [Permissions.JSEModule],
      },
      {
        title: 'Scaffoling Register',
        icon: 'fa fa-file-invoice-dollar',
        link: '/jse/scaffolding',
        data: [Permissions.JSEModule],
      },
      {
        title: 'Reports',
        icon: 'fa fa-file-invoice-dollar',
        link: '/jse/reports',
        data: [Permissions.JSEModule],
      },

    ]

  },
  {
    title: 'Detailed WIP Report',
    icon: 'fa fa-file-invoice-dollar',
    link: '/detailedwip/index',
    expanded: false,
    data: [Permissions.ViewDetailedWIPReport]
  },
  {
    title: 'Tenders',
    icon: 'fa fa-user',
    expanded: false,
    data: [Permissions.TenderRegister],
    children: [
      {
        title: 'Tender Register',
        icon: 'fa fa-file-invoice-dollar',
        link: 'primaryUrl/tender/tenders',
        data: [Permissions.TenderRegister],
      },
      //{
      //  title: 'Scopes',
      //  icon: 'users',
      //  link: '/tender/scopes',
      //  data: [Permissions.TenderRegister, Permissions.SuperAdmin],
      //},
      //{
      //  title: 'Dashboard',
      //  icon: 'fa fa-chart-line',
      //  link: 'primaryUrl/tender/reports',
      //  data: [Permissions.TenderRegister],
      //}
    ]
  },
  {
    title: 'Scaffolding Requisitions',
    icon: 'fa fa-th',
    data: [Permissions.ScaffoldMaterialRequestAdmin, Permissions.ScaffoldMaterialRequestOfficer, Permissions.ScaffoldMaterialRequestor, Permissions.ScaffoldMaterialRequestApprover, Permissions.ScaffoldMaterialRequestReports],

    children: [
      {
        title: 'Requests',
        icon: 'fa fa-th',
        link: 'primaryUrl/scaffolding-material/requests',
        data: [Permissions.ScaffoldMaterialRequestAdmin, Permissions.ScaffoldMaterialRequestOfficer, Permissions.ScaffoldMaterialRequestor, Permissions.ScaffoldMaterialRequestApprover],
      },

      {
        title: 'Reports',
        icon: 'fa fa-chart-line',
        link: 'primaryUrl/scaffolding-material/reports',
        data: [Permissions.ScaffoldMaterialRequestReports],
      },

    ]

  },
  //{
  //  title: 'UI Features',
  //  icon: 'nb-keypad',
  //  link: '/pages/ui-features',
  //  children: [
  //    {
  //      title: 'Buttons',
  //      link: '/pages/ui-features/buttons',
  //    },
  //    {
  //      title: 'Grid',
  //      link: '/pages/ui-features/grid',
  //    },
  //    {
  //      title: 'Icons',
  //      link: '/pages/ui-features/icons',
  //    },
  //    {
  //      title: 'Modals',
  //      link: '/pages/ui-features/modals',
  //    },
  //    {
  //      title: 'Popovers',
  //      link: '/pages/ui-features/popovers',
  //    },
  //    {
  //      title: 'Typography',
  //      link: '/pages/ui-features/typography',
  //    },
  //    {
  //      title: 'Animated Searches',
  //      link: '/pages/ui-features/search-fields',
  //    },
  //    {
  //      title: 'Tabs',
  //      link: '/pages/ui-features/tabs',
  //    },
  //  ],
  //},
  //{
  //  title: 'Forms',
  //  icon: 'nb-compose',
  //  children: [
  //    {
  //      title: 'Form Inputs',
  //      link: '/pages/forms/inputs',
  //    },
  //    {
  //      title: 'Form Layouts',
  //      link: '/pages/forms/layouts',
  //    },
  //  ],
  //},
  //{
  //  title: 'Components',
  //  icon: 'nb-gear',
  //  children: [
  //    {
  //      title: 'Tree',
  //      link: '/pages/components/tree',
  //    }, {
  //      title: 'Notifications',
  //      link: '/pages/components/notifications',
  //    },
  //  ],
  //},
  //{
  //  title: 'Maps',
  //  icon: 'nb-location',
  //  children: [
  //    {
  //      title: 'Google Maps',
  //      link: '/pages/maps/gmaps',
  //    },
  //    {
  //      title: 'Leaflet Maps',
  //      link: '/pages/maps/leaflet',
  //    },
  //    {
  //      title: 'Bubble Maps',
  //      link: '/pages/maps/bubble',
  //    },
  //    {
  //      title: 'Search Maps',
  //      link: '/pages/maps/searchmap',
  //    },
  //  ],
  //},
  //{
  //  title: 'Charts',
  //  icon: 'nb-bar-chart',
  //  children: [
  //    {
  //      title: 'Echarts',
  //      link: '/pages/charts/echarts',
  //    },
  //    {
  //      title: 'Charts.js',
  //      link: '/pages/charts/chartjs',
  //    },
  //    {
  //      title: 'D3',
  //      link: '/pages/charts/d3',
  //    },
  //  ],
  //},
  //{
  //  title: 'Editors',
  //  icon: 'nb-title',
  //  children: [
  //    {
  //      title: 'TinyMCE',
  //      link: '/pages/editors/tinymce',
  //    },
  //    {
  //      title: 'CKEditor',
  //      link: '/pages/editors/ckeditor',
  //    },
  //  ],
  //},
  //{
  //  title: 'Tables',
  //  icon: 'nb-tables',
  //  children: [
  //    {
  //      title: 'Smart Table',
  //      link: '/pages/tables/smart-table',
  //    },
  //  ],
  //},
  //{
  //  title: 'Miscellaneous',
  //  icon: 'nb-shuffle',
  //  children: [
  //    {
  //      title: '404',
  //      link: '/pages/miscellaneous/404',
  //    },
  //  ],
  //},
  //{
  //  title: 'Auth',
  //  icon: 'nb-locked',
  //  children: [
  //    {
  //      title: 'Login',
  //      link: '/auth/login',
  //    },
  //    {
  //      title: 'Register',
  //      link: '/auth/register',
  //    },
  //    {
  //      title: 'Request Password',
  //      link: '/auth/request-password',
  //    },
  //    {
  //      title: 'Reset Password',
  //      link: '/auth/reset-password',
  //    },
  //  ],
  //},
];
